import VueRouter from 'vue-router';
// import INO from '@/views/ino/index.vue';
import HomePage from '@/views/HomePage.vue';
// import GameMarket from '@/views/Marketplace/GameMarket.vue';
// import ArtworkMarket from '@/views/Marketplace/ArtworkMarket.vue';
import AssetDetail from '@/views/Marketplace/AssetDetail.vue';
import MyCollection from '@/views/MyCollection/MyCollection.vue';
// import Create from '@/views/Create/Create.vue';
import Listing from '@/views/Listing/Listing.vue';
import ComingSoonPage from '@/views/ComingSoon.vue';
import MarketBunicornGame from '@/views/Marketplace/MarketBunicornGame.vue';

function createRouter() {
  const router = new VueRouter({
    routes: [
      {
        path: '/',
        name: 'home',
        meta: { title: 'Homepage' },
        component: HomePage
      },
      {
        path: '/assets/:nftContract/:nftId',
        name: 'asset-detail',
        meta: { title: 'AssetDetail' },
        component: AssetDetail
      },
      {
        path: '/market/bunicorn-game',
        name: 'market-bunicorn-game',
        meta: { title: 'Market bunicorn game' },
        component: MarketBunicornGame
      },
      {
        path: '/artwork-market',
        name: 'artwork-market',
        meta: { title: 'ArtworkMarket' },
        component: ComingSoonPage
      },
      {
        path: '/my-collection',
        name: 'my-collection',
        meta: { title: 'MyCollection' },
        component: MyCollection
      },
      {
        path: '/my-collection/assets',
        name: 'my-collection/assets',
        meta: { title: 'MyCollection', tab: 'assets' },
        component: MyCollection
      },
      {
        path: '/my-collection/on-market',
        name: 'my-collection/on-market',
        meta: { title: 'MyCollection', tab: 'on-market' },
        component: MyCollection
      },
      {
        path: '/create',
        name: 'create',
        meta: { title: 'Create' },
        component: ComingSoonPage
      },
      {
        path: '/listing/:nftContract/:nftId',
        name: 'listing',
        meta: { title: 'Listing' },
        component: Listing
      },
      {
        path: '/mystery-box',
        name: 'mystery-box',
        meta: { title: 'Mystery Box' },
        component: ComingSoonPage
      },
      {
        path: '/profile',
        name: 'profile',
        meta: { title: 'Profile' },
        component: ComingSoonPage
      },
      {
        path: '/resources',
        name: 'resources',
        meta: { title: 'Resources' },
        component: ComingSoonPage
      }
    ]
  });
  return router;
}

export default createRouter;
